import { FormControl, InputAdornment, InputLabel, MenuItem, Select } from "@mui/material";
import {
    ReactElement,
    HTMLAttributes
} from "react";
import { DangerSquare, Star } from "../../assets";
import LoadingSpinner from "./loading_spinner";
interface Props extends HTMLAttributes<HTMLElement> {
    loading?:boolean;
    value: any;
    title?: string,
    onChange?: any;
    myStyle?: string;
    lable?: string;
    displayEmpty?: boolean;
    placeholder?: string;
    icon?: ReactElement;
    iconBorder?: boolean;
    hasNotice?: boolean;
    isRequired?: boolean;
    items?: any;
    error?: any;
    objectList?: boolean;
    contentLoading?: boolean;
    disabled?: boolean;

}

export function Dropdown({ value,loading, onChange, title, myStyle, lable, disabled ,  displayEmpty, placeholder, icon, iconBorder, hasNotice, isRequired, items, error, objectList, contentLoading }: Props): ReactElement {
    return (
        <div className={`${myStyle && myStyle} custom-dropdown`} >
            {lable &&
                <>
                    {contentLoading ?
                        <div className="input-loading-lable content-loading">
                        </div>
                        :
                        <label className="custom-dropdown-lable">
                            {isRequired && <img src={Star} alt="هامرز"/>}  {lable}  {hasNotice && <img src={DangerSquare} alt="هامرز"/>}

                        </label>
                    }
                </>
            }
                <FormControl className="dropdown" >
            {contentLoading ? <div className="content-loading w-100">
            </div> :
            <>
            {title && <InputLabel className="dropdown-title">{title}</InputLabel>}
                    <Select
                        value={value}
                        error={error ? true : false}

                        label={title ? title : ""}
                        displayEmpty={displayEmpty}
                        placeholder={placeholder ? placeholder : ""}
                        onChange={onChange}
                        className="dropdown-select"
                disabled={disabled && !error}

                        startAdornment={
                            icon &&
                            <InputAdornment position="end" >
                                {icon}
                                {iconBorder &&
                                    <div className="dropdown-select-icon-border">
                                    </div>
                                }
                            </InputAdornment>
                        }
                    >
                        <MenuItem disabled value="">
                        {placeholder}
                        </MenuItem>
                        {
                        loading ?
                        <div className="handle-loading-btn search-container-icon pt-2">
                        <LoadingSpinner />
                        </div>
                       
                    : 
                    items && items?.map((item: any, index: number) => {
                        return (
                            <MenuItem value={objectList ? item?.value : item} key={index}>{objectList ? item?.title : item}</MenuItem>
                        )
                    })
                    }
                    </Select>

                    {error &&
                        <label className="dropdown-select-error">
                            {error}
                        </label>
                    }
            </>
                   
                }
                </FormControl>
        </div>

    );
}

export default Dropdown;